export const CONTACT_LINK =
    'https://river.amazon.com/BOS12/workflows?buildingType=ARLExT&q0=23682267-25a3-4faa-b4a9-5ceb65d66c60&q1=81cc7c0c-8f26-4679-a67c-680932334103&q2=c6142c77-656b-46b7-b565-08489accf39a&id=c6142c77-656b-46b7-b565-08489accf39a';
